export default __webpack_public_path__ + "static/media/map-black.9820af7b.svg";